import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { merge } from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { FormatDatasetAdapter } from 'app/model/adapters/datasets/format-dataset.adapter';
import { IcebergDataset } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(IcebergDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            schema: '*',
            parameters: '*',
            type: '*',
            linkedServiceName: '*',
            linkedService: '*',
            connectionSettings: __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                location: '*'
            }
        }
    }
})
export class IcebergDatasetAdapter extends FormatDatasetAdapter<IcebergDataset, Model.DatasetV2Resource> {
    protected async _toResource(dataset: IcebergDataset): Promise<Model.DatasetV2Resource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetV2Resource;
        const modelDataset = this.properties(modelDatasetResource) as Model.IcebergDataset;
        modelDataset.type = Metamodel.modelFor(IcebergDataset).name;
        modelDataset.typeProperties = modelDataset.typeProperties || {};
        if (dataset.location) {
            modelDataset.typeProperties.location = this.locationToResource(dataset);
        }
        modelDataset.schema = this.columnValueToResource(dataset, dataset.columns);
        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetV2Resource, dataset?: IcebergDataset): Promise<IcebergDataset> {
        if (!dataset) {
            dataset = IcebergDataset.MODEL.create<IcebergDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        if (modelDatasetResource?.properties?.typeProperties?.location) {
            await this.locationToModel(modelDatasetResource, dataset);
        }

        dataset.columns = this.columnResourceToValue(dataset, modelDatasetResource.properties.schema);

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, IcebergDataset.MODEL));
        return dataset;
    }
}
